.topBlock {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  z-index: 10;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.topBlock::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 140px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%);
  z-index: 0;
}

:global([data-hovered]) .topBlock {
  opacity: 1;
}

.clipInfo {
  position: absolute;
  top: var(--spacing\/3, 24px);
  left: var(--spacing\/3, 24px);
  display: flex;
  flex-direction: column;
  gap: var(--spacing\/1, 8px);
  max-width: min(460px, calc(100% - 48px));
  pointer-events: auto;
  z-index: 1;
}

.authorLine {
  font-family: var(--typography\/typeface\/font, 'Open Sans', sans-serif);
  font-weight: var(--typography\/weight\/regular, 400);
  font-size: var(--font\/fontsize\/body-p, 16px);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  margin: 0;
}

.authorName {
  color: var(--color\/text\/link-bright, #b8d5ff);
  text-decoration: none;
}

.authorName:hover {
  text-decoration: underline;
}

.clipTitle {
  font-family: var(--typography\/typeface\/font, 'Open Sans', sans-serif);
  font-weight: var(--typography\/weight\/semibold, 600);
  font-size: var(--font\/fontsize\/h4, 20px);
  line-height: 1.5;
  color: var(--color\/text\/text-primary, #fff);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.streamerRow {
  display: flex;
  align-items: center;
  gap: var(--spacing\/1, 8px);
}

.streamerAvatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius\/xs, 2px);
  object-fit: cover;
  flex-shrink: 0;
}

.streamerName {
  font-family: var(--typography\/typeface\/font, 'Open Sans', sans-serif);
  font-weight: var(--typography\/weight\/regular, 400);
  font-size: var(--font\/fontsize\/body-p, 16px);
  line-height: 1.7;
  color: var(--color\/text\/link-bright, #b8d5ff);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playingIn {
  font-family: var(--typography\/typeface\/font, 'Open Sans', sans-serif);
  font-weight: var(--typography\/weight\/regular, 400);
  font-size: var(--font\/fontsize\/body-p, 16px);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  flex-shrink: 0;
}

.gamePill {
  background: var(--color\/button\/opacity-button-default, rgba(68, 83, 126, 0.5));
  padding: var(--spacing\/half, 4px) var(--spacing\/2, 16px);
  border-radius: var(--radius\/3xl, 360px);
  font-family: var(--typography\/typeface\/font, 'Open Sans', sans-serif);
  font-weight: var(--typography\/weight\/regular, 400);
  font-size: var(--font\/fontsize\/body-small, 14px);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  white-space: nowrap;
  flex-shrink: 0;
}

.viewerBadge {
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  overflow: hidden;
  white-space: nowrap;
  pointer-events: none;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  z-index: 1;
}

.viewerBadge svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  fill: currentColor;
}

@media (min-width: 1750px) {
  .clipTitle {
    font-size: 24px;
  }

  .streamerAvatar {
    width: 42px;
    height: 42px;
  }
}

@media (max-width: 580px) {
  .topBlock::before {
    height: 104px;
  }

  .clipInfo {
    top: 12px;
    left: 12px;
    max-width: calc(100% - 24px);
  }

  .streamerAvatar {
    width: 28px;
    height: 28px;
  }

  .clipTitle {
    font-size: 14px;
  }

  .viewerBadge {
    top: 12px;
    right: 12px;
  }
}
